import Api from './Api'

const END_POINT = 'gasto'

export default {
    async get_all(filters = null) {
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}`, request)
    },
    async store(gasto) {
        return await Api.post(`${END_POINT}`, gasto)
    },
    async update(gasto) {
        return await Api.patch(`${END_POINT}/${gasto.id}`, gasto)
    },
    async change_status(gasto) {
        return await Api.patch(`${END_POINT}/${gasto.id}/change-status`, gasto)
    },
    async delete(gasto) {
        return await Api.delete(`${END_POINT}/${gasto.id}`, gasto)
    }
}